import { Chip } from '@mui/material';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';

import CustomButton from '../../../common/CustomButton';

import { GetPatientInfoSummaryPrompt, SavePatientInfoSummaryPrompt, SuggestProgram, UpdatePatientSuggestedProgram, } from "../../../redux/brg/actions";
import { getAge } from '../../../utils/date';
import CustomActionButton from '../../../common/CustomActionButton';
import { delay } from '../../../utils';

function SuggestedPrograms(props) {
    const [prompt, setPrompt] = useState("");
    const [temporaryPrompt, setTemporaryPrompt] = useState(null);

    const [newSuggestedPrograms, setNewSuggestedPrograms] = useState("");
    const [summaryPrompt, setSummaryPrompt] = useState("");

    const { programs, patient } = props;

    useEffect(() => {
        props.GetPatientInfoSummaryPrompt();
    }, []);

    useEffect(() => {
        if (props.Brg.patientSummaryPrompt?.id) {
            setPrompt(props.Brg.patientSummaryPrompt?.text);
        }
    }, [props.Brg.patientSummaryPrompt?.id])

    const savePrompt = async (showPrompt = true) => {
        let tp = prompt;
        if (temporaryPrompt) {
            tp = temporaryPrompt;
            setPrompt(p => tp);
            setTemporaryPrompt(t => null);
        }

        const res = await props.SavePatientInfoSummaryPrompt(props.Brg.patientSummaryPrompt?.id, tp);

        if (res) {
            showPrompt && toast.success("Prompt saved!");
        } else {
            showPrompt && toast.error("Failed to save prompt!");
        }

        return tp;
    }


    const processPrompt = (patient, pPrompt) => {
        let processed = pPrompt;
        processed = processed.replace("{patientName}", patient?.first_name + " " + patient?.last_name);
        processed = processed.replace("{patientAge}", getAge(patient?.dob));
        processed = processed.replace("{patientGender}", `${{ m: "MALE", f: "FEMALE" }?.[patient?.gender] || "N/A"}`);

        processed = processed.replace("{goal_1}", patient?.goal_1);
        processed = processed.replace("{goal_2}", patient?.goal_2);
        processed = processed.replace("{goal_3}", patient?.goal_3);

        processed = processed.replace("{subjectiveSummary}", `${patient?.subjective_summary || "none"}`);
        processed = processed.replace("{objectiveSummary}", `${patient?.objective_summary || "none"}`);
        processed = processed.replace("{assessmentSummary}", `${patient?.assessment_summary || "none"}`);
        processed = processed.replace("{planSummary}", `${patient?.plan_summary || "none"}`);

        processed = processed.replace("{primaryLimitation}", `${patient?.primary_limitation || "none"}`);
        processed = processed.replace("{secondaryLimitation}", `${patient?.secondary_limitation || "none"}`);

        return processed;
    }

    const handleGenerateSP = async (pPrompt, toastID) => {
        const processedPrompt = await processPrompt(props?.patient, pPrompt);

        const res = await props.SuggestProgram(processedPrompt);
        if (res.success) {
            setNewSuggestedPrograms(res.suggestProgram);
            setSummaryPrompt(res.summary);

            toast.success('Programs Retrieved!', {
                id: toastID,
            });
        } else {

            setNewSuggestedPrograms("");
            setSummaryPrompt("");

            toast.error('Failed to Retrieve Programs!', {
                id: toastID,
            });
        }
    }


    const newSP = newSuggestedPrograms ? props.getSuggestedPrograms(newSuggestedPrograms, 20) : null;

    return (
        <>
            <div className="brg-pp-pi-group suggested-programs-v2">

                <h5>Current Suggested Programs:</h5>
                <div className="row sp-list">
                    <div className="col-md-6">
                        <Chip label={`${programs[0]?.title?.toUpperCase()} ${programs[0]?.level ? (" - " + programs[0]?.level) : ""} (${programs[0]?.type?.toUpperCase()})`} variant="outlined" />
                    </div>
                    <div className="col-md-6">
                        <Chip label={`${programs[1]?.title?.toUpperCase()} ${programs[1]?.level ? (" - " + programs[1]?.level) : ""} (${programs[1]?.type?.toUpperCase()})`} variant="outlined" />
                    </div>
                    <div className="col-md-6">
                        <Chip label={`${programs[2]?.title?.toUpperCase()} ${programs[2]?.level ? (" - " + programs[2]?.level) : ""} (${programs[2]?.type?.toUpperCase()})`} variant="outlined" />
                    </div>

                </div>

                <div className="row sp-prompt-wrapper">
                    <pre contentEditable={true} onInput={(e) => {
                        setTemporaryPrompt(e.target.outerText);
                    }}>
                        {`${prompt}`}
                    </pre>
                </div>

                {
                    summaryPrompt && (
                        <>
                            <h5>Generated Summary:</h5>
                            <div className="row sp-prompt-wrapper">
                                <pre>
                                    {`${summaryPrompt}`}
                                </pre>
                            </div>
                        </>
                    )
                }

                {
                    newSP && newSP.length > 0 && (
                        <>
                            <h5>New Suggested Programs:</h5>
                            <div className="row" style={{ marginBottom: "10px" }}>
                                {
                                    newSP?.map((nsp, i) => {
                                        return (
                                            <div className={`col-md-6 ${i < 3 ? "nsp-main" : ""}`}>
                                                <Chip label={`${nsp?.title?.toUpperCase()} ${nsp?.level ? (" - " + nsp?.level) : ""} (${nsp?.type?.toUpperCase()})`} variant="outlined" />
                                            </div>
                                        )

                                    })
                                }
                            </div>
                            <CustomActionButton action={async () => {
                                return await props.UpdatePatientSuggestedProgram(props.patient.id, newSuggestedPrograms);
                            }}>
                                Accept Programs
                            </CustomActionButton>
                        </>
                    )
                }

                <div id="generate-email-wrapper">
                    <CustomButton size="small" className='mr-4' isPrimary={false} onClick={() => {
                        savePrompt();
                    }}>
                        SAVE PROMPT
                    </CustomButton>

                    <CustomButton size="small" onClick={async () => {
                        const toastID = toast.loading("Retrieving new Suggestions...");
                        const tp = await savePrompt(false);
                        handleGenerateSP(tp, toastID);
                    }}>
                        SUGGEST PROGRAMS
                    </CustomButton>
                </div>

            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    Brg: state.Brg
})

export default connect(mapStateToProps, {
    GetPatientInfoSummaryPrompt,
    SavePatientInfoSummaryPrompt,
    SuggestProgram,
    UpdatePatientSuggestedProgram,
})(SuggestedPrograms);
